import { render, staticRenderFns } from "./SingleCollection.tpl?vue&type=template&id=25068ec1&"
import script from "./SingleCollection.vue?vue&type=script&lang=ts&"
export * from "./SingleCollection.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCollection.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports